export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";



// WEBPACK FOOTER //
// ./src/modules/preference/constants.js